import React, { useState } from "react";
import { DatePicker } from "antd";

const MaterialLikeDatePicker = ({ label, value, onChange, required, readOnly, disabled }) => {
    const [focused, setFocused] = useState(false);

    return (
        <div className={`mui-input-container ${(focused || value) ? "focused" : ""}`}>
            <label className="mui-label">
                {/* {(focused || value) && required && <span className="required-star">*</span>} */}
                {required && <span className="required-star">*</span>}{label}
            </label>

            <DatePicker
                value={value}
                onChange={onChange}
                onFocus={() => setFocused(true)}
                onBlur={() => setFocused(false)}
                className="mui-input"
                style={{ width: "100%", height: "46px" }}
                // bordered={false}
                placeholder={null}
                // placeholder={focused ? "Select Date" :label}
                disabled={disabled}
                readOnly={readOnly}
            />
            <span className="mui-underline" />
        </div>
    );
};

export default MaterialLikeDatePicker;
